import autoformPlaceholder from '../images/autoform-unselected.png';
import WrapperEmptyState from 'components/layout/WrapperEmptyState';
import PageWrapper from 'components/utils/PageWrapper';
import BiddingStrategiesAdminPage from 'pages/BiddingStrategiesAdmin';
import biddingStrategyPlaceholder from '../images/bidding-strategy-unselected.png';
import BiddingStrategies from 'pages/BiddingStrategies';
import BiddingStrategy from 'components/biddingStrategy/BiddingStrategy';
import AutoformPage from 'pages/AutoformPage';
import { ReactComponent as BatteryIcon } from '../icons/item-icons/battery-secondary.svg';
import { ReactComponent as CalendarIcon } from '../icons/calendar.svg';
import AutoformContainer from 'components/autoform/AutoformContainer';
import { Navigate } from 'react-router-dom';
import { BIDDING_STRATEGIES_ROUTES } from 'constants/routes';

export const biddingStrategiesRoutes = {
    path: '/bidding-strategies',
    element: (
        <PageWrapper titleId="bidding_strategies_title">
            <BiddingStrategiesAdminPage />
        </PageWrapper>
    ),
    children: [
        {
            index: true,
            element: <Navigate to={`${BIDDING_STRATEGIES_ROUTES.STRATEGIES}/${window.location.search}`} />,
        },
        {
            path: BIDDING_STRATEGIES_ROUTES.STRATEGIES,
            element: <BiddingStrategies />,
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState
                            imgSrc={biddingStrategyPlaceholder}
                            page="Bidding Strategy"
                            noun="properties"
                        />
                    ),
                },
                {
                    path: ':strategyId',
                    element: <BiddingStrategy />,
                },
            ],
        },
        {
            path: BIDDING_STRATEGIES_ROUTES.PSBATADMINPERIODS,
            element: (
                <AutoformPage
                    config={{
                        autoformId: BIDDING_STRATEGIES_ROUTES.PSBATADMINPERIODS,
                        itemIcon: CalendarIcon,
                        autoformIcon: CalendarIcon,
                    }}
                    hasSecondaryMenu={true}
                />
            ),
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />
                    ),
                },
                {
                    path: ':itemId',
                    element: <AutoformContainer />,
                },
            ],
        },
        {
            path: BIDDING_STRATEGIES_ROUTES.PSBATADMINPRODUCTS,
            element: (
                <AutoformPage
                    config={{
                        autoformId: BIDDING_STRATEGIES_ROUTES.PSBATADMINPRODUCTS,
                        itemIcon: BatteryIcon,
                        autoformIcon: BatteryIcon,
                    }}
                    hasSecondaryMenu={true}
                />
            ),
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />
                    ),
                },
                {
                    path: ':itemId',
                    element: <AutoformContainer />,
                },
            ],
        },
        {
            path: BIDDING_STRATEGIES_ROUTES.PSBATADMINDAYTYPES,
            element: (
                <AutoformPage
                    config={{
                        autoformId: BIDDING_STRATEGIES_ROUTES.PSBATADMINDAYTYPES,
                        itemIcon: BatteryIcon,
                        autoformIcon: BatteryIcon,
                    }}
                    hasSecondaryMenu={true}
                />
            ),
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />
                    ),
                },
                {
                    path: ':itemId',
                    element: <AutoformContainer />,
                },
            ],
        },
    ],
};
